import useSortableGrid from '@modules/sortable-grid/composables/useSortableGrid';
import { ComputedRef, Ref, INumericPagination } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

/**
 *
 * @param {{currentSortby: ComputedRef<string>, pageIndexInitial: Ref<number>}} param0
 * @returns {INumericPagination}
 */
export default function useNumericPagination({
  currentSortby,
  pageIndexInitial,
}) {
  const {
    pagination,
    updateSearchUrl,
  } = useSortableGrid();

  const pageSelectHandle = (productsPerPage, pageIndex) => {
    pageIndexInitial.value = pageIndex;

    /**
     * Int conversion needed here because it is int on MCOM
     * and string on BCOM
     */
    const currentPageIndex = parseInt(pagination?.value?.pageIndex, 10);

    /**
     * Only triggers the update search method
     * if not the same page index user is already in.
     * Needed to avoid jump to top issue on
     * initial load.
     */
    /* istanbul ignore else */
    if (Number.isInteger(currentPageIndex) && currentPageIndex !== pageIndex) {
      updateSearchUrl([
        { key: 'Productsperpage', value: productsPerPage },
        { key: 'Sortby', value: currentSortby.value },
        { key: 'Pageindex', value: pageIndex },
      ]);
    }
  };

  /**
   *
   * @param {number} productsPerPage
   * @param {number} pageIndex
   */
  const onNextClick = (productsPerPage, pageIndex) => {
    pageSelectHandle(productsPerPage, pageIndex);
  };

  /**
   *
   * @param {number} productsPerPage
   * @param {number} pageIndex
   */
  const onPageNumberClick = (productsPerPage, pageIndex) => {
    pageSelectHandle(productsPerPage, pageIndex);
  };

  /**
   *
   * @param {number} productsPerPage
   * @param {number} pageIndex
   */
  const onPreviousClick = (productsPerPage, pageIndex) => {
    pageSelectHandle(productsPerPage, pageIndex);
  };

  return {
    onNextClick,
    onPageNumberClick,
    onPreviousClick,
    pageSelectHandle,
  };
}
